<template>
  <div class="wrapper" id="qnaDetails">
    <div class="insureProcess" id="anchor-1"></div>
    <div class="premiumPaymentInstructions" id="anchor-2">
      <div class="title">保费支付说明</div>
      <div>（投保人为单位/公司的，付款账户必须是该公司/单位账户，不接受个人付款。）</div>
      <ul class="paymentInfoList">
        <li v-if="insCompanyId == 452 || insCompanyId == 0">
          <div>人保财团体意外伤害保险</div>
          <div>
            <span>账号名称：</span>
            <span>中国人民财产保险股份有限公司上海市分公司</span>
          </div>
          <div>
            <span>开户银行：</span>
            <span>中国银行上海市定西路支行</span>
          </div>
          <div>
            <span>银行账号：</span>
            <span>455966764475</span>
          </div>
        </li>
        <li v-if="insCompanyId == 453 || insCompanyId == 0">
          <div style="text-align: center">阳光财团体意外险2020特别升级版</div>
          <div>
            <span>账号名称：</span>
            <span>阳光财产保险股份有限公司上海市分公司</span>
          </div>
          <div>
            <span>开户银行：</span>
            <span>中国银行上海市延吉中路支行</span>
          </div>
          <div>
            <span>银行账号：</span>
            <span>454666946146</span>
          </div>
        </li>
        <li v-if="insCompanyId == 451 || insCompanyId == 0">
          <div style="text-align: center">平安财雇主责任险2021版/平安团e宝雇主普通版</div>
          <div>
            <span>账号名称：</span>
            <span>中国平安财产保险股份有限公司上海分公司</span>
          </div>
          <div>
            <span>开户银行：</span>
            <span>平安银行股份有限公司上海北京西路支行</span>
          </div>
          <div>
            <span>银行账号：</span>
            <span>11014491518001</span>
          </div>
        </li>
      </ul>
      <div class="explain">
        <div>说明： </div>
        <div>1.按照订单金额转账至上述账户，并保留银行回单； </div>
        <div>2.投保时付款方式选择线下支付； </div>
        <div>3.按页面要求填写信息、上传银行回单和订单截屏（含有订单金额），点击打开对应操作页面； </div>
        <div>4.保险公司到账审核时效：法定节假日时效较慢，工作时间过5个小时未到账的，保险公司会以未到账处理，投保人需要核实转账情况后重新申请;</div>
        <div>5.保险公司到账审核成功会发送短信提醒；</div>
      </div>
    </div>
    <div class="invoiceApplicationProcess" id="anchor-3"></div>
    <div class="baoQuanProcess" id="anchor-4"></div>
    <div class="service"></div>
  </div>
</template>

<script>
    export default {
      name: "qnaDetails",
      data() {
        return {
          insCompanyId: 0,
          index: 1,
        }
      },
      methods: {

      },
      mounted() {
        this.insCompanyId = this.$$.isValidObj(this.$route.query.insCompanyId) ? this.$route.query.insCompanyId : 0;
        this.index = this.$$.isValidObj(this.$route.query.index) ? this.$route.query.index : 1;

        let div = document.getElementById(`anchor-${this.index}`),
          loginStatus = parseInt($('.loginStatus').height()),
          pageTop = parseInt($('.pageTop').height());

        window.scrollTo(0, div.offsetTop + loginStatus + pageTop);
      }
    }
</script>

<style scoped>
  .wrapper{
    height: 100%;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    position: relative;
    background: #FFFFFF;
    overflow-y: scroll;
  }

  .insureProcess{
    max-height: 37rem;
    padding-top: 30%;
    background: url("../../../../static/images/product/q&aDetails/q&aDetails-1.png") no-repeat center / cover;
  }
  .invoiceApplicationProcess{
    max-height: 39.75rem;
    padding-top: 33%;
    background: url("../../../../static/images/product/q&aDetails/q&aDetails-2.png") no-repeat center / cover;
  }
  .baoQuanProcess{
    max-height: 30.5rem;
    padding-top: 25%;
    background: url("../../../../static/images/product/q&aDetails/q&aDetails-3.png") no-repeat center / cover;
  }
  .service{
    max-height: 22.75rem;
    padding-top: 19%;
    background: url("../../../../static/images/product/q&aDetails/q&aDetails-4.png") no-repeat center / cover;
  }

  .premiumPaymentInstructions{
    color: #999999;
    font-size: 1rem;
    text-align: center;
    padding: 4rem 10%;
  }
  .premiumPaymentInstructions>.title{
    color: #333333;
    font-size: 2.49rem;
    font-weight: bold;
  }

  .premiumPaymentInstructions>.explain{
    text-align: left;
    line-height: 2rem;
    padding: 0 8vw;
  }

  .paymentInfoList{
    width: 60%;
    margin: 0 auto;
    text-align: center;
    padding: 3rem 0 1rem;
  }
  .paymentInfoList>li{
    background: #FFFFFF;
    box-shadow: 0px 3px 10px 3px rgba(50, 45, 45, 0.14);
    border-radius: 6px;
    text-align: center;
    margin-bottom: 2rem;
    padding: 1rem 4rem;
    display: block;
  }
  .paymentInfoList>li>div{
    text-align: left;
    line-height: 2.5rem;
    display: flex;
  }
  .paymentInfoList>li>div:first-child{
    text-align: center;
    display: block;
    padding-bottom: .5rem;
  }

  .paymentInfoList>li>div>span:first-child{
    width: 5rem;
    margin: auto 0;
  }
  .paymentInfoList>li>div>span:nth-child(2){
    width: calc(100% - 5.5rem);
  }
</style>



// WEBPACK FOOTER //
// src/components/product/employerInsurance/qnaDetails.vue